import { getPickleballDrillTableName } from "./pickleballDrillSkills";

const mainField = "id";

const toDisplayNumber = (value) => {
    if (value === null || value === undefined || value === "") {
        return "0";
    }
    return String(value);
};

const readSkillInputData = (row) => {
    let input = row.skill_input_data;
    if (typeof input === "string") {
        try {
            input = JSON.parse(input);
        } catch (error) {
            input = {};
        }
    }
    return input || {};
};

const dataFieldConfig = [
    {
        id: "created_at",
        field: "created_at",
        align: "center",
        disablePadding: false,
        label: "參與時間",
    },
    {
        id: "display_name",
        field: "display_name",
        align: "center",
        disablePadding: false,
        label: "參與者名字",
    },
    {
        id: "group",
        field: "group",
        align: "center",
        disablePadding: false,
        label: "班別",
    },
    {
        id: "group_num",
        field: "group_num",
        align: "center",
        disablePadding: false,
        label: "班號",
    },
    {
        id: "skill_code",
        field: "skill_code",
        align: "center",
        disablePadding: false,
        label: "技能",
    },
    {
        id: "hit_count",
        field: "hit_count",
        align: "center",
        disablePadding: false,
        label: "成功次數",
    },
    {
        id: "bonus_count",
        field: "bonus_count",
        align: "center",
        disablePadding: false,
        label: "BONUS次數",
    },
    {
        id: "hit_score",
        field: "hit_score",
        align: "center",
        disablePadding: false,
        label: "基本得分",
    },
    {
        id: "bonus_score",
        field: "bonus_score",
        align: "center",
        disablePadding: false,
        label: "BONUS得分",
    },
    {
        id: "skill_score",
        field: "skill_score",
        align: "center",
        disablePadding: false,
        label: "總得分",
    },
];

const fetchDataConfig = {
    url: "/memberSkillData/query",
};

const tableActionConfig = [];

const fetchResultModifier = (data) => {
    data.forEach((row) => {
        const input = readSkillInputData(row);
        row.hit_count = toDisplayNumber(input.hit_count);
        row.bonus_count = toDisplayNumber(input.bonus_count);
        row.hit_score = toDisplayNumber(input.hit_score);
        row.bonus_score = toDisplayNumber(input.bonus_score);
        if (row.skill_score === 0) {
            row.skill_score = "0";
        }
        row.skill_code = getPickleballDrillTableName(row.skill_code);
    });
};

const TableConfig = {
    mainField,
    dataFieldConfig,
    fetchDataConfig,
    tableActionConfig,
    fetchResultModifier,
};

export default TableConfig;
